export default __webpack_public_path__ + "assembly73506f5.png";